/**
 * Pushes data to the Google Tag Manager dataLayer array.
 *
 * @param {Object} data - Data to push to dataLayer.
 */
const pushToDataLayer = data => {
  if (!window.dataLayer) window.dataLayer = [];
  window.dataLayer.push(data);
};

/**
 * Pushes search analytics data to the dataLayer.
 *
 * @param {Array<String>} filters - Selected filters at the time of the search.
 * @param {String} city - Search result city.
 * @param {String} zip - Search result zip code.
 * @param {String} state - Search result state.
 * @param {String} country - Search result country.
 */
export const pushSearchInteraction = ({ filters, city, zip, state, country }) =>
  pushToDataLayer({
    event: 'find-us',
    interaction: 'search',
    label: filters.join(','),
    FindUsSearch: `<${city}, ${zip}, ${state}, ${country}>`,
  });

/**
 * Pushes location analytics data to the dataLayer.
 *
 * @param {String} type - Location type.
 * @param {String} id - Location Id.
 */
export const pushLocationInteraction = ({ type, id }) =>
  pushToDataLayer({
    event: 'find-us',
    interaction: 'view-detail',
    label: type,
    FindUsLocation: id,
  });

/**
 * Push primary CTA analytics data to the dataLayer.
 */
export const pushPrimaryCTAInteraction = () =>
  pushToDataLayer({
    event: 'find-us',
    interaction: 'view-detail',
    label: 'schedule-test-drive',
  });

/**
 * Push secondary CTA analytics data to the dataLayer.
 */
export const pushSecondaryCTAInteraction = () =>
  pushToDataLayer({
    event: 'find-us',
    interaction: 'view-detail',
    label: 'view-all-locations',
  });

/**
 * Push primary CTA analytics data to the dataLayer.
 */
export const pushTripPlannerInteraction = () =>
  pushToDataLayer({
    event: 'find-us',
    interaction: 'view-detail',
    label: 'explore-route',
  });
